import * as s from "../ModalTemplateStyled";
import * as mediaQuery from "components/MediaQuery";

import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import SmallPopupDefaultTemplate from "./SmallPopupDefaultTemplate";
import PrimaryButton from "components/atoms/buttons/PrimaryButton";
import { useAppSelector } from "redux/hooks";
import { forwardRef } from "react";

type Props = {
  title: string | JSX.Element;
  titleIcon?: JSX.Element;
  subTitle?: string;
  children: React.ReactNode;
  onModal?: () => void;
  onClick: () => void;
  deactivate?: boolean;
  disableClose?: boolean;
  cancel?: boolean;
  confirmLabel?: string;
  buttons?: React.ReactNode;
  className?: string;
};

const SmallPopupTemplate = forwardRef<HTMLDivElement, Props>(
  (
    {
      title,
      titleIcon,
      subTitle,
      children,
      onModal,
      onClick,
      deactivate,
      disableClose,
      cancel,
      confirmLabel,
      buttons,
      className = "",
    }: Props,
    ref
  ): JSX.Element => {
    const theme = useAppSelector((state) => state.theme.theme);
    const buttonsComponent = buttons ? (
      buttons
    ) : deactivate || cancel ? (
      <s.ButtonWrapper>
        <PrimaryButton
          buttonType="cancel"
          label="Cancel"
          onClickBtn={onModal as () => void}
          data-testid="templates-modal-small-primary-button-click"
        />

        <PrimaryButton
          label={confirmLabel ? confirmLabel : "OK"}
          onClickBtn={onClick}
          data-testid="templates-modal-small-primary-button-click-2"
        />
      </s.ButtonWrapper>
    ) : (
      <PrimaryButton
        label={confirmLabel ? confirmLabel : "Next"}
        onClickBtn={onClick}
        data-testid="templates-modal-small-primary-button-click-3"
      />
    );

    return (
      <SmallPopupDefaultTemplate
        disableClose={disableClose}
        button={buttonsComponent}
        onModal={onModal}
        ref={ref}
        className={className}
      >
        {deactivate ? (
          <s.SmallDeactivateTitle>
            {titleIcon && titleIcon}
            {title}
            <Text color={COLORS.COMPANY} fontSize={14}>
              {subTitle}
            </Text>
          </s.SmallDeactivateTitle>
        ) : (
          <s.SmallTitleWrapper>
            <h2>
              {titleIcon && titleIcon}
              {title}
            </h2>
            {subTitle && <p className="subtitle">{subTitle}</p>}
          </s.SmallTitleWrapper>
        )}

        <s.SmallContents>{children}</s.SmallContents>
      </SmallPopupDefaultTemplate>
    );
  }
);

export default SmallPopupTemplate;
